<template>
  <!-- 介绍说明页 -->
  <div class="introduce-page">
    <div  class="tabs-page">
      <ul v-if="introduceList.length" class="tabs">
        <li
          v-for="(item) in introduceList"
          :key='item.type' class="tab"
          :class="{'active' : tipsActiveStore == item.type}"
          @click="changeTab(item.type)">
          <span>{{ item.label }}</span>
        </li>
        <!-- 接口的 -->
        <!-- <template v-if="consoleTipsList && consoleTipsList.length">
          <li
            v-for="(item,indexApi) in consoleTipsList"
            :key='indexApi' class="tab"
            :class="{'active' : tipsActiveStore == item.title}"
            @click="changeTab(item.title, indexApi)">
            <span>{{ item.title }}</span>
          </li>
        </template> -->
      </ul>
      <div class="page-content">
        <div class="content-wrapper" v-html="viewContent"></div>

        <!-- <div v-show="tipsActiveStore == 'weight1'" class="content-wrapper">
          <div>
            <p>港澳台特快专递：</p>
            <span>寄澳门单件邮件最大重量不超过31.5千克，寄香港、台湾单件邮件最大重量不超过30千克。</span>
          </div>
          <div>
            <p>港澳台航空包裹：</p>
            <span>寄澳门单件邮件最大重量不超过31.5千克，寄香港、台湾单件邮件最大重量不超过30千克。</span>
          </div>
          <div>
            <p>港澳台水陆路包裹：</p>
            <span>寄澳门单件邮件最大重量不超过31.5千克，寄香港、台湾单件邮件最大重量不超过30千克。</span>
          </div>
        </div> -->
        <!-- 接口返回的 -->
        <!-- <template v-if="consoleTipsList && consoleTipsList.length">
          <div class="content-wrapper" v-show="tipsActiveStore == consoleTipsList[indexApi].title">
            <div v-html="consoleTipsList[indexApi].content"></div>
          </div>
        </template> -->
      </div>
    </div>
    <!-- 底部按钮 -->
    <footer class="footer-box">
      <div class="btn-box" @click="goBack"><span>好的，我知道了</span></div>
    </footer>
  </div>
</template>

<script>
import { mapState } from 'vuex'
import { isiOS, checkBrowser } from '../../plugin/channel/setUserChannel'
import introduceObj from './js/introduceObj'

export default {
  components: {},
  props: {},
  data () {
    return {
      frontVueChannel: this.$route.query.frontVueChannel || 0, // 1微信公众号h5  2微信小程序h5  3支付宝公众号h5 4支付宝小程序h5
      indexApi: 0 // 接口返回的索引
    }
  },
  filters: {},
  computed: {
    isiOS () {
      return isiOS()
    },
    isWechatMini () {
      return checkBrowser() === 'WECHAT_MINI_PROGRAM'
    },
    ...mapState('consoleTips', {
      tipsActiveStore: state => state.tipsActive || 'weight' // weight protect volume product
      // consoleTipsList: state => state.consoleTipsList.consoleTipsBusiness // 接口返回的说明
    }),
    ...mapState('freightMain', {
      tabActiveStore: state => state.tabActive // land:国内 sar:港澳台 int:国际
    }),
    // tabList + 内容List
    introduceList () {
      const areaType = this.tabActiveStore || 'land'
      let list = [...(introduceObj[areaType] || [])]

      if (this.isWechatMini) {
        const hasEms = list.some(item => item.type === 'ems') // 用 type 判断最准
        if (!hasEms) {
          list.push(introduceObj.emsTab)
        }
      } else {
        list = list.filter(item => item.type !== 'ems')
      }

      return list
    },
    // 当前显示的内容
    viewContent () {
      const introduceItem = this.introduceList.find((item) => item.type === this.tipsActiveStore)
      return introduceItem.content
    }
  },
  watch: {},
  created () {
  },
  mounted () {
  },
  methods: {
    // 切换tab
    changeTab (type, indexApi) {
      // if (indexApi || indexApi === 0) {
      //   this.indexApi = indexApi
      // }
      this.$store.dispatch('consoleTips/setTipsActive', type)
    },
    // 返回主页
    goBack () {
      // if (this.frontVueChannel === 2) {
      //   // 微信小程序h5
      //   wx.miniProgram.navigateBack({
      //     delta: 1 // 返回上一级页面。
      //   })
      // } else if (this.frontVueChannel === 2) {
      //   // 支付宝小程序h5
      //   // eslint-disable-next-line no-undef
      //   my.navigateBack()
      // } else {
      //   // 公众号H5
      //   this.$router.replace('/index')
      // }

      // this.$router.go(-1)
      this.$router.back()
      // window.history.back()
    }
  } /* methods末 */
}
</script>

<style lang="scss" scoped>
@import "./css/introducePage.scss"
</style>
